import create, { GetState, SetState } from "zustand";

export type DataStore = {
  countryCode: string;
  setCountryCode: (countryCode: string) => void;
  currencySymbol: string;
  setCurrencySymbol: (currencySymbol: string) => void;
  showScheduleDemoModal: boolean;
  openScheduleFormOnScheduleCTAClick: boolean;
  setShowScheduleDemoModal: (show: boolean) => void;
  setOpenScheduleFormOnScheduleCTAClick: (open: boolean) => void;
  // Slug of the active CMS-driven marketing page, or empty string when the
  // current route is not a CMS page. Replaces the `path.startsWith("/page/")`
  // checks that broke when product/feature/page URL prefixes were dropped —
  // a flat `/<slug>` URL gives no syntactic clue that it's a marketing page.
  marketingPageSlug: string;
  setMarketingPageSlug: (slug: string) => void;
};

export const useDataStore = create<DataStore>(
  (set: SetState<DataStore>, get: GetState<DataStore>) => ({
    countryCode: "",
    setCountryCode: (countryCode: string) => {
      set((state) => {
        state.countryCode = countryCode;
      });
    },
    currencySymbol: "",
    setCurrencySymbol: (currencySymbol: string) => {
      set((state) => {
        state.currencySymbol = currencySymbol;
      });
    },
    showScheduleDemoModal: false,
    openScheduleFormOnScheduleCTAClick: false,
    setShowScheduleDemoModal: (show: boolean) => {
      set((state) => {
        state.showScheduleDemoModal = show;
      });
    },
    setOpenScheduleFormOnScheduleCTAClick: (open: boolean) => {
      set((state) => {
        state.openScheduleFormOnScheduleCTAClick = open;
      });
    },
    marketingPageSlug: "",
    setMarketingPageSlug: (slug: string) => {
      set((state) => {
        state.marketingPageSlug = slug;
      });
    },
  })
);
